<template lang="pug">
  main
    NavBar
    ModalDelete(v-show="modalStatus" :title="titleModal" :content="contentModal" @padre:eliminar="eliminarMovimiento")
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Movimiento de Tarjetas&nbsp
              a.button.is-black.is-rounded(@click="backToPage")
                i.fas.fa-times
        .columns
          .column.is-2
            .field
              .control
                flat-pickr(
                  v-model='fechaPeriodo'
                  :config="config"
                  class="input"
                )
          .column.is-2
            router-link.a.button.is-success.is-rounded(to="/Transportes/Tarjetas/Movimientos/Importar")
              span.icon
                i.fas.fa-file-excel
              | &nbsp Importar
            | &nbsp
            a.button.is-black.is-rounded(@click="descargarMovs")
              span.icon
                i.fas.fa-file-excel
              | &nbsp Descargar
        .columns
          .column.is-12
            Tb_MovimientosTarjetas(:movs="movimientosShow" @reloadTable="reloadTable" @eliminarMovimiento="verModalEliminar")
        .columns.column-blanco
</template>

<script>
  import NavBar from './layout/NavBarTransportes.vue'
  import Loader from '@/components/shared/Loader.vue'
  import ModalDelete from '@/components/shared/ModalDelete.vue'
  import Tb_MovimientosTarjetas from './componentes/Tb_MovimientosTarjetas.vue'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import InventarioServices from '@/services/inventario/inventario'
  import moment from 'moment'
  import { mapState } from 'vuex'

  export default {
    name: 'Tarjetas',
    components: { NavBar, Loader, flatPickr, Tb_MovimientosTarjetas, ModalDelete },
    data() {
      return {
        isLoading: true,
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m',
          altInput: true,
          dateFormat: 'Y-m',
          locale: Spanish, // locale for this instance only          
        },
        fechaPeriodo: moment().format('YYYY-MM'),
        movimientos: [],
        movimientosShow: [],
        movimientoSelect: {},
        query: '',
        filter: 'ALL',
        result_query: '',
        modalStatus: false,
        titleModal: '',
        contentModal: '',
      }
    },
    watch: {
      fechaPeriodo() {
        this.obtenerMovimientos()
      }
    },
    methods: {
      iniciarComponente () {
        this.obtenerMovimientos()
      },

      obtenerMovimientos () {
        const periodo = `${moment(this.fechaPeriodo).format('YYYYMM')}`
        console.log(periodo)
        InventarioServices.getTarjetas_Movimientos(periodo, this.userLogin.ubicacion, this.userLogin.cargo)
          .then( data => {
            this.movimientos = data.map(this.convertirMovs)
            this.movimientosShow = this.movimientos
            this.isLoading = false
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'OK')      
          })
      },

      convertirMovs (mov) {
        return {
          ...mov,
          id: parseInt(mov.id),
          abono: Number(mov.abono),
          cargo: Number(mov.cargo),
          tipo: parseInt(mov.tipo),
          transaccion: parseInt(mov.transaccion),
          id_ticket: parseInt(mov.id_ticket)
        }
      },

      verModalEliminar () {

      },

      eliminarMovimiento () {

      },

      reloadTable () {
        this.obtenerMovimientos()
      },

      displayToast(tema,text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      backToPage () {
        this.$router.back()
      },

      descargarMovs() {
        const periodo = `${moment(this.fechaPeriodo).format('YYYYMM')}`
        InventarioServices.createExcel_TarjetasKilometros(periodo)
          .then((res) => {
            const currentUrl = window.location.hostname
            if (res.success) {
              open(`https://${currentUrl}/reportesApp/server/excel/tarjetas_kilometros_down.php?nameFile=${res.file}`, '_blank');
              setTimeout(() => {
                InventarioServices.borrarInventario_Ubicacion(res.file)
                  .then( resDel => {
                    this.isLoading = false
                  })
                  .catch((e) => {
                    this.isLoading = false
                    this.displayToast(e.message, 'ban', 'OK')
                  })
              }, 4000)
            } else {
              this.displayToast(res.respuesta, 'ban', 'OK')
            }
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast(e.message, 'ban', 'OK')
          })
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
    ...mapState(['userLogin'])
  },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/TarjetasMovimientos.vue